export enum CourseStatus {
  Åpnet = "åpnet",
  Planlagt = "planlagt",
  Utsatt = "utsatt",
  Innstilt = "innstilt",
  Avsluttet = "avsluttet",
  Slettet = "slettet",
}
